import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import SaveIcon from '@mui/icons-material/Save';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Download from '@mui/icons-material/Download';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { reset as resetList, resetConfig, listSaveAction, listStartExportAction } from '../actions';
import { reset as resetFilter } from '../filter/actions';
import _ from 'lodash';
import { hasText } from 'src/utils';
import { getPrincipal, AccessLevel, Principal } from 'src/auth';


const GridMenu: React.FC<{
    anchorEl: Element | null,
    onClose: () => void,
    gridName?: string,
}> = ({
    anchorEl,
    onClose,
    gridName,
}) => {
        const dispatch = useDispatch();
        const [saveDialogOpen, setSaveDialogOpen] = useState(false);
        const [name, setName] = useState<string>(gridName || '');
        const principal = getPrincipal();

        const handleReset = () => {
            dispatch(resetConfig());
            onClose();
        }

        const handleExport = () => {
            dispatch(listStartExportAction());
            onClose();
        }

        const handleSaveAs = () => {
            onClose();
            setSaveDialogOpen(true);
        }

        const handleSave = () => {
            setSaveDialogOpen(false);
            if (hasText(name)) {
                dispatch(listSaveAction(name));
            }
            onClose();
        }

        const handleCloseDialog = () => {
            setSaveDialogOpen(false);
        }

        return <>
            <Popover
                id={'grid-menu-popover'}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <MenuList>
                    {
                        principal.hasAccessResource('_grid', AccessLevel.Manage) &&
                        <MenuItem disabled={gridName == null} onClick={handleSave}>
                            <ListItemIcon>
                                <SaveIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Save</ListItemText>
                        </MenuItem>
                    }
                    {
                        principal.hasAccessResource('_grid', AccessLevel.Manage) && <MenuItem onClick={handleSaveAs}>
                            <ListItemIcon>
                                <SaveAsIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Save As...</ListItemText>
                        </MenuItem>
                    }
                    {
                        principal.hasAccessResource('_grid', AccessLevel.Manage) && <Divider />
                    }
                    <MenuItem onClick={handleExport}>
                        <ListItemIcon>
                            <Download fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{'Export'}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={handleReset}>
                        <ListItemIcon>
                            <RestartAltIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{'Reset'}</ListItemText>
                    </MenuItem>
                </MenuList>
            </Popover >

            {
                <Dialog
                    open={saveDialogOpen}
                    onClose={handleCloseDialog}
                    PaperProps={{
                        component: 'form',
                        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                            event.preventDefault();
                            handleSave();
                            handleCloseDialog();
                        },
                    }}
                >
                    <DialogContent>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            name="name"
                            label="Grid name"
                            type="string"
                            fullWidth
                            variant="standard"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} variant='outlined'>Cancel</Button>
                        <Button type="submit" variant='contained'>Save</Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    }

export default GridMenu;
